import DCompaniesDataView from "./DCompaniesDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchDCompany from "./SearchDCompany";


const defaultFilterData: IDCompanySearchForm = {
  description: "",
  sapCode: "",
  unID: "",
  deleted: "",
  placeID: ""
}

const DCompanies = () => {
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView title="Αναζήτηση Θυγατρικής">
        <SearchDCompany />
      </SydFilterView>

      <DCompaniesDataView />

    </SydFilterProvider>
  )
}

export default DCompanies;
